// extracted by mini-css-extract-plugin
export default {"content":"TitleItemMoby_content__6K84L","linkTitle":"TitleItemMoby_linkTitle__XDMhe"};